import { Component, computed } from '@angular/core';
import { Toast } from 'ngx-toastr';
import { NotificationMessageLevels } from '../../models/websocket.models';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatRipple } from '@angular/material/core';
import { Notification } from '../../models/users-profile.models';

@Component({
  selector: 'app-toast',
  imports: [FontAwesomeModule, MatRipple],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent extends Toast {
  notification = computed(() => this.options().payload as Notification);

  iconsMap: Record<NotificationMessageLevels, { name: string; color: string }> = {
    [NotificationMessageLevels.LEVEL_SUCCESS]: {
      name: 'circle-check',
      color: '#22C55E',
    },
    [NotificationMessageLevels.LEVEL_ERROR]: {
      name: 'circle-xmark',
      color: '#EF4444',
    },
    [NotificationMessageLevels.LEVEL_INFO]: {
      name: 'circle-info',
      color: '#3B82F6',
    },
    [NotificationMessageLevels.LEVEL_WARNING]: {
      name: 'circle-exclamation',
      color: '#F59E0B',
    },
  };
}
